


























































































import Vue from 'vue'
import api, { ApiResponse } from '../../../../api'

export default Vue.extend({
  data() {
    return {
      loading: false,
      linkSent: false,
      accountNotFound: false,
      form: {
        email: ''
      }
    }
  },

  methods: {
    onSubmit() {
      this.loading = true
      api.requestPasswordReset(this.form).then((response: ApiResponse) => {
        this.loading = false

        if (response.isSuccessful) {
          this.linkSent = true
          //
        } else if (response.isNotFound) {
          this.accountNotFound = true
        }
      })
    }
  }
})
